import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { inv2022 } from "../../utils";
import "../Css/inv.css";
export default function Pi() {
  const { id, year } = useParams();
  const [invdata, setInvdata] = useState({});
  useEffect(() => {
    axios
      .get(`${inv2022}/${id}/taxinvoice/${year}`)
      .then((res) => {
        setInvdata(res.data);

        console.log(
          new Date(res.data.invoice.created_on) >= new Date("2022-04-14")
        );
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <div className="invdEtaModal">
      <div className="inv_contain">
        <span className="tax_head">Proforma Invoice</span>
        <div className="mt-3 d-flex justify-content-between">
          <img
            src={"https://admin.taskmo.in/images/taskmo_new.png"}
            alt="ott"
            className="logo_left_css"
          />
          <div className="date_data_css">
            <span className="right_tax_css">
              #TMB/
              {year == "2022" ? "22-23" : year == "2021" ? "21-22" : "20-21"}/
              {invdata?.invoice?.invoice_number <= "99" &&
              invdata?.invoice?.invoice_number >= "1"
                ? `0${invdata?.invoice?.invoice_number}`
                : invdata?.invoice?.invoice_number <= "999" &&
                  invdata?.invoice?.invoice_number >= "100"
                ? `0${invdata?.invoice?.invoice_number}`
                : invdata?.invoice?.invoice_number}
            </span>
            <span className="right_tax_css">
              Date: {moment(invdata?.invoice?.created_on).format("DD-MM-YYYY")}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column">
          <span className="head_bill_css">Bill To</span>
          <span className="legal_name_css">{invdata?.client?.companyname}</span>
          <div className="legal_name_css1">
            {invdata?.client?.billing_address}
          </div>
          <div className="d-flex align-items-end">
            <span className="head_bill_css mt-1">GSTIN : </span>
            <span className="legal_name_css">{invdata?.client?.gstno}</span>
          </div>
          <div className="d-flex align-items-end">
            <span className="head_bill_css">Place of Supply : </span>
            <span className="legal_name_css">{invdata?.client?.state}</span>
          </div>
        </div>
        <table class="table table-bordered my-3" style={{ width: "100%" }}>
          <thead class="bg-gray-200">
            <tr>
              <th scope="col" style={{ width: "50%" }}>
                <b
                  className="float-left"
                  style={{ fontSize: "15px", fontWeight: 700 }}
                >
                  Description
                </b>
              </th>
              <th style={{ width: "10%" }}>
                <b
                  class="float-right"
                  style={{ fontSize: "15px", fontWeight: 700 }}
                >
                  HSN/SAC
                </b>
              </th>
              <th style={{ width: "10%" }}>
                <b
                  class="float-right"
                  style={{ fontSize: "15px", fontWeight: 700 }}
                >
                  Quantity
                </b>
              </th>
              <th style={{ width: "10%" }}>
                <b
                  class="float-right"
                  style={{ fontSize: "15px", fontWeight: 700 }}
                >
                  Cost
                </b>
              </th>
              <th style={{ width: "15%" }}>
                <b
                  class="float-right"
                  style={{ fontSize: "15px", fontWeight: 700 }}
                >
                  Amount (Rs.)
                </b>
              </th>
            </tr>
          </thead>
          <tbody>
            {invdata?.desc?.map((res) => {
              return (
                <tr>
                  <td
                    style={{ verticalAlign: "bottom !important", width: "55%" }}
                    className="desc_box_css"
                  >
                    <h1 class="text-dark">
                      <b
                        style={{
                          marginBottom: "5px",
                          fontSize: "16px",
                          fontWeight: 600,
                          display: "flex",
                        }}
                      >
                        {res.description}
                      </b>
                    </h1>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle !important",
                      width: "10%",
                    }}
                  >
                    <b
                      class="float-right"
                      style={{ fontSize: "16px", textAlign: "center" }}
                    >
                      {res.hsn}
                    </b>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle !important",
                      width: "10%",
                    }}
                  >
                    <b
                      class="float-right"
                      style={{ fontSize: "16px", textAlign: "center" }}
                    >
                      {res.quantity}
                    </b>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle !important",
                      width: "10%",
                    }}
                  >
                    <b
                      class="float-right"
                      style={{ fontSize: "16px", textAlign: "center" }}
                    >
                      {res.cost}
                    </b>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle !important",
                      width: "15%",
                    }}
                  >
                    <b
                      class="float-right"
                      style={{ fontSize: "16px", textAlign: "center" }}
                    >
                      {res.amount}
                    </b>
                  </td>
                </tr>
              );
            })}

            <tr class="bg-gray-100">
              <td colSpan={4}>
                <b
                  style={{ marginBottom: "5px", fontSize: "14px" }}
                  class="float-right"
                >
                  Sub Total
                </b>
              </td>
              <td style={{ textAlign: "right" }}>
                <b
                  style={{ marginBottom: "5px", fontSize: "14px" }}
                  class="float-right"
                >
                  {invdata?.invoice?.amount}
                </b>
              </td>
            </tr>

            {invdata?.client?.state === "Karnataka (KA)" ? (
              <>
                <tr>
                  <td colSpan={4}>
                    <b
                      style={{ marginBottom: "5px", fontSize: "14px" }}
                      class="float-right"
                    >
                      CGST (9%)
                    </b>
                  </td>
                  <td>
                    <b
                      style={{ marginBottom: "5px", fontSize: "14px" }}
                      class="float-right"
                    >
                      {invdata?.cgst}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <b
                      style={{ marginBottom: "5px", fontSize: "14px" }}
                      class="float-right"
                    >
                      SGST (9%)
                    </b>
                  </td>
                  <td>
                    <b
                      style={{ marginBottom: "5px", fontSize: "14px" }}
                      class="float-right"
                    >
                      {invdata?.sgst}
                    </b>
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan={4}>
                  <b
                    style={{ marginBottom: "5px", fontSize: "14px" }}
                    class="float-right"
                  >
                    IGST (18%)
                  </b>
                </td>
                <td>
                  <b
                    style={{ marginBottom: "5px", fontSize: "14px" }}
                    class="float-right"
                  >
                    {invdata?.igst}
                  </b>
                </td>
              </tr>
            )}

            <tr class="bg-gray-100">
              <td colSpan={4}>
                <b
                  style={{ marginBottom: "5px", fontSize: "14px" }}
                  class="float-right"
                >
                  Total Amount
                </b>
              </td>
              <td style={{ textAlign: "right", fontWeight: "bold" }}>
                <b
                  style={{ marginBottom: "5px", fontSize: "16px" }}
                  class="float-right"
                >
                  {invdata.totalAmount}
                </b>
              </td>
            </tr>
            <tr>
              <td colspan="5" class="text-center">
                <b
                  style={{
                    marginBottom: "5px",
                    fontSize: "15px",
                    float: "right",
                  }}
                  class="float-right; "
                >
                  Amount In Words : {invdata?.amount_in_words} only
                </b>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ paddingBottom: "15px" }}>
          <div class="invoice-summary">
            <span>
              <img
                src={window.location.origin + "/images/Seal.png"}
                alt=""
                width="200"
                border="0"
                style={{
                  width: "100%",
                  maxWidth: "150px",
                  height: "auto",
                  marginTop: "5px",
                  float: "right",
                }}
              />
            </span>
          </div>
        </div>
        <div style={{ position: "fixed", bottom: "0px" }}>
          <table
            class="table mb-4"
            style={{
              display: "flex",
              justifyContent: "left",
              textAlign: "left",
              width: "100vw",
            }}
          >
            <tbody>
              <tr>
                <td style={{ width: "100%", borderTop: "none" }}>
                  <h4 class="font-weight-bold text-dark">Account Details:</h4>
                  <h4
                    class="text-dark"
                    style={{ fontSize: "20px", marginBottom: "0rem" }}
                  >
                    <span
                      style={{
                        fontWeight: 700,
                        fontStyle: "italic",
                        fontSize: "20px",
                      }}
                    >
                      Account Name :
                    </span>
                    &nbsp;
                    <span style={{ fontSize: "20px" }}>
                      STELLARSLOG TECHNOVATION PVT LTD
                    </span>
                    <br />
                    <span
                      style={{
                        fontWeight: 700,
                        fontStyle: "italic",
                        fontSize: "20px",
                      }}
                    >
                      Bank Name :
                    </span>
                    &nbsp;
                    <span style={{ fontSize: "20px" }}>HDFC Bank </span>
                    <br />
                    <span
                      style={{
                        fontWeight: 700,
                        fontStyle: "italic",
                        fontSize: "20px",
                      }}
                    >
                      Account No. :
                    </span>
                    &nbsp;
                    <span style={{ fontSize: "20px" }}>50200071637751</span>
                    <br />
                    <span
                      style={{
                        fontWeight: 700,
                        fontStyle: "italic",
                        fontSize: "20px",
                      }}
                    >
                      IFSC Code :
                    </span>
                    &nbsp;
                    <span style={{ fontSize: "20px" }}>HDFC0002850</span>
                  </h4>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: "16px", marginBottom: "0rem" }}>
              <span className="footer-higlight">
                STELLARSLOG TECHNOVATION PVT LTD
              </span>
              <br />
              Mohan Chambers, #31, 1st Main Road, 3rd Phase JP Nagar, Bangalore
              - 560078 <br />
              <span className="footer-higlight"> GSTIN : 29AAWCS4663E1ZP </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
